// appsActions.js
import { SET_USERCONTEXT } from '../types/userContextConstants'

export function setUserContext(userContext) {
  return {
    type: SET_USERCONTEXT,
    payload: userContext
  }
}
